import ViewQuizLayout from 'components/ViewQuiz/ViewQuizLayout';

const Desktop = (props) => <ViewQuizLayout device={'desktop'} {...props} />;

export default Desktop;
